import styled, { css } from 'styled-components';

export const Container = styled.div`
  width: 100%;
  gap: 26px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;

  span.title-section {
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 28px;
    color: #475467;
    cursor: pointer;

    svg {
      border-radius: 50%;
      cursor: pointer;
      transition: 0.6s;
      transform: ${props =>
        !props.showHide ? 'rotate(-180deg)' : 'rotate(0deg)'};
    }
  }

  @media only screen and (max-width: 950px) {
    padding-left: 16px;
  }
`;

export const GridVacancies = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  overflow-y: auto;
  overflow-x: hidden;
  transition: 0.6s;
  min-height: 120px;
  ${props =>
    !props.showHide &&
    css`
      min-height: 0px;
      height: 0px;
    `}
  @media only screen and (max-width: 950px) {
    display: flex;
  }
`;
